export const DEFAULT_INTERNAL_MONTHS = 240;
export const colombiaToday = () => new Date(Date.now() - 5 * 3600000).toISOString().slice(0, 10);
export const internalType = value => [4, 5, 9, 10, 13].includes(Number(value));
export function addValidityMonths(value, months = DEFAULT_INTERNAL_MONTHS) {
  const count = Number(months);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "") || !Number.isInteger(count) || count < 1 || count > 1200) return "";
  const date = new Date(`${value}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return "";
  const day = date.getUTCDate();
  date.setUTCDate(1);
  date.setUTCMonth(date.getUTCMonth() + count);
  const last = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
  date.setUTCDate(Math.min(day, last));
  return date.toISOString().slice(0, 10);
}
export function applyCreationDefaults(form, type) {
  if (form.id) return { ...form, type_document_id: type };
  const start = form.date_from || colombiaToday();
  // Do not replace a manually entered deadline when changing document types.
  const previousDefault = internalType(form.type_document_id) && form.date_to === addValidityMonths(start);
  return { ...form, type_document_id: type, date_from: start,
    date_to: internalType(type) ? form.date_to || addValidityMonths(start) : previousDefault ? "" : form.date_to };
}
